'use client';

import { useEffect, useState } from 'react';
import { useBreakpoint } from 'hooks/useBreakpoints';
import { BaseCarousel, PaginationType } from 'components/shared/Carousel/BaseCarousel';
import { carouselClassNames } from 'components/shared/Card/styles';
import SmallArticle from 'components/ArticleGrid/SmallArticle';
import { CarouselOptions } from 'types/sharedComponents';
import { ArticleGridProps, RelatedArticleProps } from './types';

interface ArticleGridCarouselProps extends Pick<ArticleGridProps, 'color'> {
  articles: RelatedArticleProps[];
}

const ArticleGridCarousel = ({ articles, color }: ArticleGridCarouselProps) => {
  const [isClient, setIsClient] = useState(false);
  const { isAboveMd } = useBreakpoint('md');
  const visibleOnSlide = isAboveMd ? 9 : 3;
  const numberOfPages = Math.ceil(articles.length / visibleOnSlide) ?? 1;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- hydration check, only runs once on mount
    setIsClient(true);
  }, []);

  const options: CarouselOptions = {
    slidesToScroll: visibleOnSlide,
    containScroll: false,
    align: 'start',
  };

  const slides = (
    <div className={'grid grid-flow-col auto-cols-[95%] md:auto-cols-[31%] grid-rows-3 gap-x-2 md:gap-x-8 gap-y-12'}>
      {articles.map((article, i) => (
        <SmallArticle {...article} key={i} />
      ))}
    </div>
  );

  return isClient ? (
    <BaseCarousel
      totalItems={numberOfPages}
      carouselClassName={carouselClassNames(color)}
      carouselPaginationClassName="mt-8"
      carouselContentClassName="w-full"
      showPaginationThreshold={1}
      carouselOpts={options}
      paginationType={PaginationType.Numeric}>
      {slides}
    </BaseCarousel>
  ) : (
    slides
  );
};

export default ArticleGridCarousel;
